import classNames from 'classnames';
import { FC } from 'react';

import styles from './personalDiscount.module.scss';

type PersonalDiscountProps = {
  className?: string;
  count: number;
};

const PersonalDiscount: FC<PersonalDiscountProps> = (props) => {
  const { className, count = 0 } = props;
  return (
    <aside className={classNames(styles.personalDiscount, className)}>
      <div className={styles.personalDiscount__wrapper}>
        <div className={styles.personalDiscount__headBlock}>
          <p className={styles.personalDiscount__head}>
            Моя персональная скидка
          </p>
        </div>
        <div className={styles.personalDiscount__textBlock}>
          <p className={styles.personalDiscount__text}>{count}%</p>
        </div>
      </div>
    </aside>
  );
};

PersonalDiscount.displayName = 'PersonalDiscount';

export default PersonalDiscount;
